import type { OptimizationGoal } from '@cast/shared-optimization-profiles';
import { DEFAULT_KENT_AGGRESSIVE_MODE_CONFIG } from '@cast/split-me/features/cluster/rebalance/constants';
import { ContinuousRebalancingConfig } from '@cast/types-kent';

export const OPTIMIZATION_GOAL_TO_KENT_CONSOLIDATION_CONFIG = {
  PERFORMANCE: {
    fullModeCycleIntervalSeconds: 900,
    drainOnlyCycleIntervalSeconds: 900,
    deleteEmptyCycleIntervalSeconds: 900,
    minNodeAgeSeconds: 900,
    mode: 'CONTINUOUS_REBALANCING_CYCLE',
    savingsThresholdPercent: 10,
    savingsThresholdCostMonthly: 0,
    minNodesToConsider: 1,
    maxNodesPerIteration: 5,
    maxCandidatesWindow: 100,
    maxBinarySearchDepth: 20,
    // Explicit empty object (not omitted) so applying this preset always
    // overwrites aggressiveModeConfig in the merge, resetting aggressive mode
    // to off even if a previously applied preset had left flags enabled.
    aggressiveModeConfig: {},
  },
  BALANCED: {
    fullModeCycleIntervalSeconds: 300,
    drainOnlyCycleIntervalSeconds: 300,
    deleteEmptyCycleIntervalSeconds: 300,
    minNodeAgeSeconds: 300,
    mode: 'CONTINUOUS_REBALANCING_CYCLE',
    savingsThresholdPercent: 5,
    savingsThresholdCostMonthly: 0,
    minNodesToConsider: 1,
    maxNodesPerIteration: 20,
    maxCandidatesWindow: 100,
    maxBinarySearchDepth: 20,
    // Explicit empty object (not omitted) so applying this preset always
    // overwrites aggressiveModeConfig in the merge, resetting aggressive mode
    // to off even if a previously applied preset had left flags enabled.
    aggressiveModeConfig: {},
  },
  COST_SAVING: {
    fullModeCycleIntervalSeconds: 300,
    drainOnlyCycleIntervalSeconds: 60,
    deleteEmptyCycleIntervalSeconds: 60,
    minNodeAgeSeconds: 60,
    mode: 'CONTINUOUS_REBALANCING_CYCLE',
    savingsThresholdPercent: 2,
    savingsThresholdCostMonthly: 0,
    minNodesToConsider: 1,
    maxNodesPerIteration: 40,
    maxCandidatesWindow: 100,
    maxBinarySearchDepth: 20,
    aggressiveModeConfig: DEFAULT_KENT_AGGRESSIVE_MODE_CONFIG,
  },
} satisfies Record<OptimizationGoal, ContinuousRebalancingConfig>;
